import { styled } from '@mui/material/styles';

export const StyledCopyrightMenu = styled('div')(
  ({ theme }) => `
    display: flex;
    justify-content: center;
    flex-flow: column nowrap;
    gap: ${theme.DS_spacing(['sm'])};
    
    ${theme.breakpoints.up('lg')} {
      flex-flow: row;
      justify-content: space-between;
    }
  `,
);

export const StyledCopyrightLabel = styled('div')(
  () => `
    display: flex;
    justify-content: center;
  `,
);

export const StyledCopyrightMenuList = styled('div')(
  ({ theme }) => `
    display: flex;
    justify-content: center;
    gap: 24px;
    
    a {
      color: ${theme.DS_palette.primary.black};
    }
  `,
);

export const StyledGroupPLLinks = styled('div')(
  ({ theme }) => `
    margin-bottom: ${theme.DS_spacing(['sm'])};
    
    p {
       color: ${theme.DS_palette.text.secondary};
       margin-bottom: ${theme.DS_spacing(['xxxs'])};
       text-transform: uppercase;
    }
   
    li {
      margin-bottom: ${theme.DS_spacing(['xxs'])};
      a {
        text-decoration-color: ${theme.DS_palette.primary.black};
        color: ${theme.DS_palette.primary.black};
      }
    }  
  
  `,
);
export const StyledPLLinks = styled('div')(
  ({ theme }) => `
     margin-bottom: ${theme.DS_spacing(['md'])};
     display: flex;
     flex-direction: column;
      ${theme.breakpoints.up('lg')} {
         flex-direction: row;
         justify-content: space-between;
    }
  `,
);
